import Http from '@/api/http_v2.js'

export default {
  index(params) {
    return Http.get(`/brands`, { params })
  },

  // indexByModel(type, filter) {
  //   return Http.get(`/${type}`, {params: {...filter}})
  // },
}
